import {Link} from 'react-router-dom'
import SwiperCore, {Navigation} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import {Button} from 'reactstrap'

SwiperCore.use([Navigation]);

const SlidingHighlights = (props : any) => {
  const sliders = [
    {taxonomy_id: 'bangga-lokal', name: 'Bangga Lokal', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
    {taxonomy_id: 'fashion', name: 'Fashion', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
    {taxonomy_id: 'f-n-b', name: 'Food & Beverage', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
    {taxonomy_id: 'groceries', name: 'Groceries', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
    {taxonomy_id: 'health-beauty', name: 'Health & Beauty', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
    {taxonomy_id: 'hobi', name: 'Hobi', path: `${process.env.PUBLIC_URL}/images/lob/Banner-Per-Lob-360x294.jpg` },
  ]

  function SetCategory(category : any){
    props.resetFilter()
    props.setCategoryFilter(category)
  }
  
  return (
    <div className="SlidingHighlights">
      <Swiper
        spaceBetween={10}
        slidesPerView={"auto"}
        navigation={{
          nextEl: ".next-el",
          prevEl: ".prev-el",
        }}
        breakpoints={{
          480: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
        }}
      >
        {sliders.map((slider: any, i: number) => (
          <SwiperSlide key={i}>
            <div className="shadow CardOverlay">
              <img
                src="https://www.bca.co.id/-/media/Images/Banner/20220405-promo-sakuku-thumbnail"
                className="w-100"
                alt={`Highlight ${i}`}
              />
              <div className="inner d-flex align-items-center justify-content-center">
                <Link
                  to={{
                    pathname: "/",
                    search: `?category=${slider.taxonomy_id}`,
                  }}
                  onClick={() => SetCategory([String(slider.taxonomy_id)])}
                  className="stretched-link"
                >
                  {slider.name}
                </Link>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="d-flex justify-content-end navigation-wrapper">
          <Button
            color="link"
            className="prev-el nav-slider swiper-button-disabled"
          >
            ‹
          </Button>
          <Button color="link" className="next-el nav-slider">
            ›
          </Button>
        </div>
      </Swiper>
    </div>
  );
}

export default SlidingHighlights